<template>
  <div class="mr-4">
    <div class="form-foto pr-3">
      <!-- FOTO -->
      <v-avatar size="100px">
        <v-img class="error-img" :class="currentStatus === STATUS_PHOTO.STATUS_CARGANDO ? 'persona-foto-loading' : 'persona-foto'" @click="currentStatus !== STATUS_PHOTO.STATUS_CARGANDO ? $refs.fileInput.click() : null" :src="photoSource"> </v-img>
      </v-avatar>
      <!-- <v-btn 
          @click='borrarFotoPersona'
          dark
          top
          right
          fab
          bottom
          rigth
          x-large
          class="orange">
        <img class='btn-footer-der pointer' src='@/assets/images/Btn-SUPR.gif' >
        <v-icon>delete</v-icon>
        </v-btn>-->
      <!-- FIN. FOTO @click='guardarFotoPersona'-->
      <v-btn @click="currentStatus !== STATUS_PHOTO.STATUS_CARGANDO ? $refs.fileInput.click() : null" fab small absolute class="primary">
        <!--<img class='btn-footer-der pointer' src='@/assets/images/Btn_F2.gif' >-->
        <v-icon>add_a_photo</v-icon>
      </v-btn>
      <!-- Borrar Foto -->
      <!--{{ msj.borrarfoto }}-->
    </div>

    <div>
      <input type="file" @change="onFileChange($event)" accept="image/*" class="input-file" ref="fileInput" style="display:none" />
    </div>
  </div>
</template>
<script>
import { PersonaApiService } from '@/api/PersonaApiService';
import { Util } from '@/api/Util';

const personaApiService = new PersonaApiService();
const util = new Util();

export default {
  data() {
    return {
      urlImagen: process.env.VUE_APP_URL_API_PERSONA + 'getPersonaFoto/',
      currentStatus: 2,
      urlImagenPreview: null,
      urlImagenLoading: require('@/assets/images/spinner.gif'),
      imgFile: null,
      isMountedFoto: false,
      STATUS_PHOTO: {
        STATUS_INICIAL: 0,
        STATUS_CORRECTO: 1,
        STATUS_CARGANDO: 2,
      },
      msj: {
        borrarFoto: this.$t('lang.msjconfirm.borrarfoto'),
        correcto: this.$t('lang.personas.alerta.correcto'),
        errorimagen: this.$t('lang.personas.alerta.errorImagen'),
      },
    };
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number,
    clickGuardarFotoPersona: Number,
    clickBorrarFotoPersona: Number,
  },
  watch: {
    personaParam: {
      handler(n, o) {
        // if (n.mspersonaid !== o.mspersonaid) {
        this.reset();
        // }
      },
      deep: true,
    },
    clickGuardarFotoPersona: {
      handler(n, o) {
        this.$refs.fileInput.click();
        // this.guardarImagen()
      },
      deep: true,
    },
    clickBorrarFotoPersona: {
      handler(n, o) {
        this.borrarImagen();
      },
      deep: true,
    },
  },
  computed: {
    photoSource: function() {
      // CAMBIO LA FOTO SE RECOGE AHORA DE LAS BASE DE DATOS
      // switch (this.currentStatus) {
      //   case this.STATUS_PHOTO.STATUS_INICIAL:
      //     if (this.personaParam.mspersonaconfoto === 'N') {
      //       return require('@/assets/images/no_photo.jpg')
      //     } else {
      //       return this.getImgUrl()
      //     }
      //   case this.STATUS_PHOTO.STATUS_CORRECTO:
      //     return this.urlImagenPreview
      //   case this.STATUS_PHOTO.STATUS_CARGANDO:
      //     return this.urlImagenLoading
      //   default:
      //     break
      // }
      switch (this.currentStatus) {
        case this.STATUS_PHOTO.STATUS_INICIAL:
          if (this.personaParam.mspersonaimagen === null || this.personaParam.mspersonaimagen === '') {
            return require('@/assets/images/no_photo.png');
          } else {
            return `data:image/png;base64, ${this.personaParam.mspersonaimagen}`;
          }
        case this.STATUS_PHOTO.STATUS_CORRECTO:
          return this.urlImagenPreview;
        case this.STATUS_PHOTO.STATUS_CARGANDO:
          return this.urlImagenLoading;
        default:
          break;
      }
    },
  },
  mounted() {
    // this.reset()
    // this.mountListenerTeclas()
  },
  methods: {
    reset() {
      // reiniciamos el estado de subida de imagenes
      this.personaParam.imagen = null;
      this.currentStatus = this.STATUS_PHOTO.STATUS_INICIAL;
      const input = this.$refs.fileInput;
      input.type = 'text';
      input.type = 'file';
      this.imgFile = null;
    },
    guardarImagen() {
      if (this.currentStatus === this.STATUS_PHOTO.STATUS_CORRECTO) {
        personaApiService
          .updatePersonaFoto(this.personaParam)
          .then((data) => {
            // this.personaParam.mspersonaconfoto = 'N'
            this.currentStatus = this.STATUS_PHOTO.STATUS_CARGANDO;
            this.personaParam.mspersonaimagen = data.data.mspersonaimagen;
            setTimeout(() => {
              // this.personaParam.mspersonaconfoto = 'S'
              this.currentStatus = this.STATUS_PHOTO.STATUS_INICIAL;
              this.$root.$emit('mostrarAlerta', this.msj.correcto, 'info')
            }, 1000);
            this.personaParam.imagen = null;
            util.mostrarEnConsola('PersonasTabFoto - updatePersonaFoto', data.status, 'OK');
          })
          .catch((error) => {
            this.reset();
            this.personaParam.imagen = null;
            this.$root.$emit('mostrarAlerta', this.msj.errorimagen, 'error')
            util.mostrarEnConsola('PersonasTabFoto - updatePersonaFoto', error, 'ERROR');
          });
      }
    },
    borrarImagen() {
      if (/*this.personaParam.mspersonaconfoto === 'S' && */ this.currentStatus === this.STATUS_PHOTO.STATUS_INICIAL) {
        if (confirm(this.msj.borrarFoto)) {
          personaApiService
            .deletePersonaFoto(this.personaParam)
            .then((data) => {
              this.currentStatus = this.STATUS_PHOTO.STATUS_CARGANDO;
              setTimeout(() => {
                // this.personaParam.mspersonaconfoto = 'N'
                this.currentStatus = this.STATUS_PHOTO.STATUS_INICIAL;
                this.$root.$emit('mostrarAlerta', this.msj.correcto, 'info')
              }, 1000);
              this.personaParam.imagen = null;
              util.mostrarEnConsola('PersonasTabFoto - deletePersonaFoto', data.status, 'OK');
            })
            .catch((error) => {
              this.reset();
              this.personaParam.imagen = null;
              this.$root.$emit('mostrarAlerta', this.msj.errorimagen, 'error')
              util.mostrarEnConsola('PersonasTabFoto - deletePersonaFoto', error, 'ERROR');
            });
        }
      }
    },
    getImgUrl: function() {
      // Obligamos a recargar la imagen
      return this.urlImagen + this.personaParam.mspersonauid + '?' + Math.random();
    },
    getImgPreview: function() {
      return this.urlImagenPreview;
      // return URL.createObjectURL(this.imgFile)
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.urlImagenPreview = URL.createObjectURL(file);
        this.currentStatus = this.STATUS_PHOTO.STATUS_CORRECTO;
        this.personaParam.imagen = this.$refs.fileInput.files[0];
        this.guardarImagen();
        // let reader = new FileReader()
        // let self = this
        // reader.onload = (event) => {
        //   self.personaParam.imagen = event.target.result
        //   self.urlImagenPreview = URL.createObjectURL(file)
        //   self.currentStatus = self.STATUS_PHOTO.STATUS_CORRECTO
        // }
        // reader.readAsBinaryString(file)
      }
    },
  },
};
</script>
